
































































































































































import { Component, Vue } from 'vue-property-decorator';
import Spinner from '@/components/utils/Spinner.vue'
import Disclaimer from "@/components/Disclaimer.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/common";
import { userInfoType, userStatesInfoType } from '@/types/Admin';
const commonState = namespace("Common");


import { vehicleTypeOptions } from '../utils/enums';

@Component({
    components:{
        Spinner, 
        Disclaimer       
    }
})
export default class UserProfile extends Vue {
    
    @commonState.State
    public user!: userInfoType;

    @commonState.State
    public isKeycloak!: boolean;

    disclaimer = {show: false}

    changePassword = false
    oldPassword = ''
    confirmEmail = ''
    confirmPassword = ''    

    pageReady = false;
    registering = false;
    updateProfileInfo = 0;

    dismissCountDown =0
    alertType = '';
    message = '';

    profileStates = {} as userStatesInfoType;

    userToEdit = {} as userInfoType;  
    vehicleTypeOptions;  
    
    created() {
        this.vehicleTypeOptions = vehicleTypeOptions;
    }

    mounted() {
        this.pageReady = false;
        this.registering = false;
        this.profileStates = {} as userStatesInfoType;
        this.clearStates();
        this.getUserInformation();
    }
       
    public getUserInformation(){    

        this.$http.get('/user/info')
        .then(response =>{
            this.userToEdit = response.data
            this.pageReady = true;
        },err =>{
            this.message = err.response.data.detail;
            this.alertType="danger";
            this.dismissCountDown = 3;
            this.pageReady = true;

        });                 
    }    

    public updateProfile() {

        this.clearStates();
        if (this.checkProfileStates()){

            this.registering = true;
            this.$http.put('/user/update',this.userToEdit)
            .then(response =>{
                this.registering = false;
                this.alertType="success";
                this.dismissCountDown = 3;
                this.message = "You have successfully updated your profile information."
            
            },err =>{
                this.message = err.response.data.detail;
                this.alertType="danger";
                this.dismissCountDown = 3;
                this.registering = false;                
            });   
        } 
    }

    public checkProfileStates(){

        let stateCheck = true;
    
        this.profileStates.email = null;
        this.profileStates.confirmEmail = null;        
        this.profileStates.firstName = !(this.userToEdit.first_name)? false : null;
        this.profileStates.lastName = !(this.userToEdit.last_name)? false : null;
        this.profileStates.vehicleType = !(this.userToEdit.vehicle_type)? false : null;
        this.profileStates.licensePlate = !(this.userToEdit.license_plate)? false : null;
        if (this.changePassword){
            this.profileStates.oldPassword = !(this.userToEdit.old_password)? false : null;
            this.profileStates.password = !(this.userToEdit.password)? false : null;
            this.profileStates.confirmPassword = !(this.userToEdit.password && this.confirmPassword && this.userToEdit.password == this.confirmPassword)? false : null;      
        } else {
            this.profileStates.oldPassword = null;
            this.profileStates.password = null;
            this.profileStates.confirmPassword = null;
        }

        this.updateProfileInfo ++;

        for(const field of Object.keys(this.profileStates)){
            if(this.profileStates[field]==false)
                stateCheck = false;
        }   
        return stateCheck;            
    }

    public clearStates(){
        for(const field of Object.keys(this.profileStates)){
            this.profileStates[field] = null;                
        }
    }

    public countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    }


  
}
